import { Input } from "@mantine/core";
import React from "react";

import styles from "./YachtSetup.module.scss";

export const FlexRow: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.flexRow} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const InputStyledWrapper: React.FC<
  React.ComponentProps<typeof Input.Wrapper>
> = props => (
  <Input.Wrapper className={styles.inputStyledWrapper} {...props} />
);
